module.exports = __webpack_public_path__ + "media/images/front/event/dummypic4-df4d17b8d6e589a4997c902bf2337ad1.svg";